import React from 'react'
import styled from '../../config/theme'

export default function CardColors ({ data }: CardColorsProps) {
  return (
    <Container>
      {data.map((data, index) => (
        <Card
          key={index}
          color={data.color}
        >
          <Content>{data.content}</Content>
          <Label>{data.label}</Label>
        </Card>
      ))}
    </Container>
  )
}

export interface CardColorsProps {
  data: {
    color: string
    content: string
    label: string
  }[]
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;

  @media screen and (max-width: 900px) {
    position: relative;
    overflow: auto;
    > * {
      flex-shrink: 0;
    }
  }
`

const Card = styled.div<{ color: string }>`
  background-color: ${props => props.color};
  padding: 15px;
  text-align: center;
  color: #fff;
  width: 100%;
  margin: 0 10px;
`

const Content = styled.div`
  font-size: 2.25rem;
  margin-bottom: .5rem;
`

const Label = styled.div`
  font-size: .875rem;
`
